/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as UnauthenticatedImport } from './routes/_unauthenticated'
import { Route as NeutralImport } from './routes/_neutral'
import { Route as AuthenticatedImport } from './routes/_authenticated'
import { Route as IndexImport } from './routes/index'
import { Route as UnauthenticatedSignupImport } from './routes/_unauthenticated/signup'
import { Route as UnauthenticatedResetPasswordImport } from './routes/_unauthenticated/reset-password'
import { Route as UnauthenticatedLoginImport } from './routes/_unauthenticated/login'
import { Route as UnauthenticatedForgotPasswordImport } from './routes/_unauthenticated/forgot-password'
import { Route as NeutralWaitlistImport } from './routes/_neutral/waitlist'
import { Route as NeutralAcceptInvitationImport } from './routes/_neutral/accept-invitation'
import { Route as AuthenticateduserDashboardDashboardMonitor3dImport } from './routes/_authenticated/(user-dashboard)/dashboard/_monitor-3d'
import { Route as AuthenticateduserDashboardDashboardDashboardImport } from './routes/_authenticated/(user-dashboard)/dashboard/_dashboard'
import { Route as AuthenticatedadminDashboardAdminDashboardImport } from './routes/_authenticated/(admin-dashboard)/admin/_dashboard'
import { Route as AuthenticateduserDashboardDashboardDashboardIndexImport } from './routes/_authenticated/(user-dashboard)/dashboard/_dashboard/index'
import { Route as AuthenticatedadminDashboardAdminDashboardIndexImport } from './routes/_authenticated/(admin-dashboard)/admin/_dashboard/index'
import { Route as AuthenticateduserDashboardDashboardMonitor3dSceneEditorImport } from './routes/_authenticated/(user-dashboard)/dashboard/_monitor-3d/scene-editor'
import { Route as AuthenticateduserDashboardDashboardMonitor3dMonitor3dImport } from './routes/_authenticated/(user-dashboard)/dashboard/_monitor-3d/monitor-3d'
import { Route as AuthenticateduserDashboardDashboardMonitor3d3dLiteImport } from './routes/_authenticated/(user-dashboard)/dashboard/_monitor-3d/3d-lite'
import { Route as AuthenticateduserDashboardDashboardDashboardTenantsImport } from './routes/_authenticated/(user-dashboard)/dashboard/_dashboard/tenants'
import { Route as AuthenticateduserDashboardDashboardDashboardSettingsImport } from './routes/_authenticated/(user-dashboard)/dashboard/_dashboard/settings'
import { Route as AuthenticateduserDashboardDashboardDashboardLocationsImport } from './routes/_authenticated/(user-dashboard)/dashboard/_dashboard/locations'
import { Route as AuthenticateduserDashboardDashboardDashboardAnalyticsImport } from './routes/_authenticated/(user-dashboard)/dashboard/_dashboard/analytics'
import { Route as AuthenticateduserDashboardDashboardDashboardAiInsightsImport } from './routes/_authenticated/(user-dashboard)/dashboard/_dashboard/ai-insights'
import { Route as AuthenticateduserDashboardDashboardDashboard3dMapImport } from './routes/_authenticated/(user-dashboard)/dashboard/_dashboard/3d-map'
import { Route as AuthenticateduserDashboardDashboardDashboardScenesIndexImport } from './routes/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/index'
import { Route as AuthenticateduserDashboardDashboardDashboardDevicesIndexImport } from './routes/_authenticated/(user-dashboard)/dashboard/_dashboard/devices/index'
import { Route as AuthenticateduserDashboardDashboardDashboardDevicesDeviceIdImport } from './routes/_authenticated/(user-dashboard)/dashboard/_dashboard/devices/$deviceId'
import { Route as AuthenticateduserDashboardDashboardDashboardScenesSceneIdViewNewImport } from './routes/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/$sceneId/view-new'
import { Route as AuthenticateduserDashboardDashboardDashboardScenesSceneIdViewImport } from './routes/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/$sceneId/view'
import { Route as AuthenticateduserDashboardDashboardDashboardScenesSceneIdEditorNewImport } from './routes/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/$sceneId/editor-new'
import { Route as AuthenticateduserDashboardDashboardDashboardScenesSceneIdEditorImport } from './routes/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/$sceneId/editor'

// Create Virtual Routes

const AuthenticateduserDashboardDashboardImport = createFileRoute(
  '/_authenticated/(user-dashboard)/dashboard',
)()
const AuthenticatedadminDashboardAdminImport = createFileRoute(
  '/_authenticated/(admin-dashboard)/admin',
)()

// Create/Update Routes

const UnauthenticatedRoute = UnauthenticatedImport.update({
  id: '/_unauthenticated',
  getParentRoute: () => rootRoute,
} as any)

const NeutralRoute = NeutralImport.update({
  id: '/_neutral',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedRoute = AuthenticatedImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const UnauthenticatedSignupRoute = UnauthenticatedSignupImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => UnauthenticatedRoute,
} as any)

const UnauthenticatedResetPasswordRoute =
  UnauthenticatedResetPasswordImport.update({
    id: '/reset-password',
    path: '/reset-password',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)

const UnauthenticatedLoginRoute = UnauthenticatedLoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => UnauthenticatedRoute,
} as any)

const UnauthenticatedForgotPasswordRoute =
  UnauthenticatedForgotPasswordImport.update({
    id: '/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)

const NeutralWaitlistRoute = NeutralWaitlistImport.update({
  id: '/waitlist',
  path: '/waitlist',
  getParentRoute: () => NeutralRoute,
} as any)

const NeutralAcceptInvitationRoute = NeutralAcceptInvitationImport.update({
  id: '/accept-invitation',
  path: '/accept-invitation',
  getParentRoute: () => NeutralRoute,
} as any)

const AuthenticateduserDashboardDashboardRoute =
  AuthenticateduserDashboardDashboardImport.update({
    id: '/(user-dashboard)/dashboard',
    path: '/dashboard',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedadminDashboardAdminRoute =
  AuthenticatedadminDashboardAdminImport.update({
    id: '/(admin-dashboard)/admin',
    path: '/admin',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticateduserDashboardDashboardMonitor3dRoute =
  AuthenticateduserDashboardDashboardMonitor3dImport.update({
    id: '/_monitor-3d',
    getParentRoute: () => AuthenticateduserDashboardDashboardRoute,
  } as any)

const AuthenticateduserDashboardDashboardDashboardRoute =
  AuthenticateduserDashboardDashboardDashboardImport.update({
    id: '/_dashboard',
    getParentRoute: () => AuthenticateduserDashboardDashboardRoute,
  } as any)

const AuthenticatedadminDashboardAdminDashboardRoute =
  AuthenticatedadminDashboardAdminDashboardImport.update({
    id: '/_dashboard',
    getParentRoute: () => AuthenticatedadminDashboardAdminRoute,
  } as any)

const AuthenticateduserDashboardDashboardDashboardIndexRoute =
  AuthenticateduserDashboardDashboardDashboardIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticateduserDashboardDashboardDashboardRoute,
  } as any)

const AuthenticatedadminDashboardAdminDashboardIndexRoute =
  AuthenticatedadminDashboardAdminDashboardIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedadminDashboardAdminDashboardRoute,
  } as any)

const AuthenticateduserDashboardDashboardMonitor3dSceneEditorRoute =
  AuthenticateduserDashboardDashboardMonitor3dSceneEditorImport.update({
    id: '/scene-editor',
    path: '/scene-editor',
    getParentRoute: () => AuthenticateduserDashboardDashboardMonitor3dRoute,
  } as any)

const AuthenticateduserDashboardDashboardMonitor3dMonitor3dRoute =
  AuthenticateduserDashboardDashboardMonitor3dMonitor3dImport.update({
    id: '/monitor-3d',
    path: '/monitor-3d',
    getParentRoute: () => AuthenticateduserDashboardDashboardMonitor3dRoute,
  } as any)

const AuthenticateduserDashboardDashboardMonitor3d3dLiteRoute =
  AuthenticateduserDashboardDashboardMonitor3d3dLiteImport.update({
    id: '/3d-lite',
    path: '/3d-lite',
    getParentRoute: () => AuthenticateduserDashboardDashboardMonitor3dRoute,
  } as any)

const AuthenticateduserDashboardDashboardDashboardTenantsRoute =
  AuthenticateduserDashboardDashboardDashboardTenantsImport.update({
    id: '/tenants',
    path: '/tenants',
    getParentRoute: () => AuthenticateduserDashboardDashboardDashboardRoute,
  } as any)

const AuthenticateduserDashboardDashboardDashboardSettingsRoute =
  AuthenticateduserDashboardDashboardDashboardSettingsImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticateduserDashboardDashboardDashboardRoute,
  } as any)

const AuthenticateduserDashboardDashboardDashboardLocationsRoute =
  AuthenticateduserDashboardDashboardDashboardLocationsImport.update({
    id: '/locations',
    path: '/locations',
    getParentRoute: () => AuthenticateduserDashboardDashboardDashboardRoute,
  } as any)

const AuthenticateduserDashboardDashboardDashboardAnalyticsRoute =
  AuthenticateduserDashboardDashboardDashboardAnalyticsImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AuthenticateduserDashboardDashboardDashboardRoute,
  } as any)

const AuthenticateduserDashboardDashboardDashboardAiInsightsRoute =
  AuthenticateduserDashboardDashboardDashboardAiInsightsImport.update({
    id: '/ai-insights',
    path: '/ai-insights',
    getParentRoute: () => AuthenticateduserDashboardDashboardDashboardRoute,
  } as any)

const AuthenticateduserDashboardDashboardDashboard3dMapRoute =
  AuthenticateduserDashboardDashboardDashboard3dMapImport.update({
    id: '/3d-map',
    path: '/3d-map',
    getParentRoute: () => AuthenticateduserDashboardDashboardDashboardRoute,
  } as any)

const AuthenticateduserDashboardDashboardDashboardScenesIndexRoute =
  AuthenticateduserDashboardDashboardDashboardScenesIndexImport.update({
    id: '/scenes/',
    path: '/scenes/',
    getParentRoute: () => AuthenticateduserDashboardDashboardDashboardRoute,
  } as any)

const AuthenticateduserDashboardDashboardDashboardDevicesIndexRoute =
  AuthenticateduserDashboardDashboardDashboardDevicesIndexImport.update({
    id: '/devices/',
    path: '/devices/',
    getParentRoute: () => AuthenticateduserDashboardDashboardDashboardRoute,
  } as any)

const AuthenticateduserDashboardDashboardDashboardDevicesDeviceIdRoute =
  AuthenticateduserDashboardDashboardDashboardDevicesDeviceIdImport.update({
    id: '/devices/$deviceId',
    path: '/devices/$deviceId',
    getParentRoute: () => AuthenticateduserDashboardDashboardDashboardRoute,
  } as any)

const AuthenticateduserDashboardDashboardDashboardScenesSceneIdViewNewRoute =
  AuthenticateduserDashboardDashboardDashboardScenesSceneIdViewNewImport.update(
    {
      id: '/scenes/$sceneId/view-new',
      path: '/scenes/$sceneId/view-new',
      getParentRoute: () => AuthenticateduserDashboardDashboardDashboardRoute,
    } as any,
  )

const AuthenticateduserDashboardDashboardDashboardScenesSceneIdViewRoute =
  AuthenticateduserDashboardDashboardDashboardScenesSceneIdViewImport.update({
    id: '/scenes/$sceneId/view',
    path: '/scenes/$sceneId/view',
    getParentRoute: () => AuthenticateduserDashboardDashboardDashboardRoute,
  } as any)

const AuthenticateduserDashboardDashboardDashboardScenesSceneIdEditorNewRoute =
  AuthenticateduserDashboardDashboardDashboardScenesSceneIdEditorNewImport.update(
    {
      id: '/scenes/$sceneId/editor-new',
      path: '/scenes/$sceneId/editor-new',
      getParentRoute: () => AuthenticateduserDashboardDashboardDashboardRoute,
    } as any,
  )

const AuthenticateduserDashboardDashboardDashboardScenesSceneIdEditorRoute =
  AuthenticateduserDashboardDashboardDashboardScenesSceneIdEditorImport.update({
    id: '/scenes/$sceneId/editor',
    path: '/scenes/$sceneId/editor',
    getParentRoute: () => AuthenticateduserDashboardDashboardDashboardRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedImport
      parentRoute: typeof rootRoute
    }
    '/_neutral': {
      id: '/_neutral'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof NeutralImport
      parentRoute: typeof rootRoute
    }
    '/_unauthenticated': {
      id: '/_unauthenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof UnauthenticatedImport
      parentRoute: typeof rootRoute
    }
    '/_neutral/accept-invitation': {
      id: '/_neutral/accept-invitation'
      path: '/accept-invitation'
      fullPath: '/accept-invitation'
      preLoaderRoute: typeof NeutralAcceptInvitationImport
      parentRoute: typeof NeutralImport
    }
    '/_neutral/waitlist': {
      id: '/_neutral/waitlist'
      path: '/waitlist'
      fullPath: '/waitlist'
      preLoaderRoute: typeof NeutralWaitlistImport
      parentRoute: typeof NeutralImport
    }
    '/_unauthenticated/forgot-password': {
      id: '/_unauthenticated/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof UnauthenticatedForgotPasswordImport
      parentRoute: typeof UnauthenticatedImport
    }
    '/_unauthenticated/login': {
      id: '/_unauthenticated/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof UnauthenticatedLoginImport
      parentRoute: typeof UnauthenticatedImport
    }
    '/_unauthenticated/reset-password': {
      id: '/_unauthenticated/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof UnauthenticatedResetPasswordImport
      parentRoute: typeof UnauthenticatedImport
    }
    '/_unauthenticated/signup': {
      id: '/_unauthenticated/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof UnauthenticatedSignupImport
      parentRoute: typeof UnauthenticatedImport
    }
    '/_authenticated/(admin-dashboard)/admin': {
      id: '/_authenticated/(admin-dashboard)/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedadminDashboardAdminImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/(admin-dashboard)/admin/_dashboard': {
      id: '/_authenticated/(admin-dashboard)/admin/_dashboard'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedadminDashboardAdminDashboardImport
      parentRoute: typeof AuthenticatedadminDashboardAdminRoute
    }
    '/_authenticated/(user-dashboard)/dashboard': {
      id: '/_authenticated/(user-dashboard)/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticateduserDashboardDashboardImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/(user-dashboard)/dashboard/_dashboard': {
      id: '/_authenticated/(user-dashboard)/dashboard/_dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticateduserDashboardDashboardDashboardImport
      parentRoute: typeof AuthenticateduserDashboardDashboardRoute
    }
    '/_authenticated/(user-dashboard)/dashboard/_monitor-3d': {
      id: '/_authenticated/(user-dashboard)/dashboard/_monitor-3d'
      path: ''
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticateduserDashboardDashboardMonitor3dImport
      parentRoute: typeof AuthenticateduserDashboardDashboardImport
    }
    '/_authenticated/(user-dashboard)/dashboard/_dashboard/3d-map': {
      id: '/_authenticated/(user-dashboard)/dashboard/_dashboard/3d-map'
      path: '/3d-map'
      fullPath: '/dashboard/3d-map'
      preLoaderRoute: typeof AuthenticateduserDashboardDashboardDashboard3dMapImport
      parentRoute: typeof AuthenticateduserDashboardDashboardDashboardImport
    }
    '/_authenticated/(user-dashboard)/dashboard/_dashboard/ai-insights': {
      id: '/_authenticated/(user-dashboard)/dashboard/_dashboard/ai-insights'
      path: '/ai-insights'
      fullPath: '/dashboard/ai-insights'
      preLoaderRoute: typeof AuthenticateduserDashboardDashboardDashboardAiInsightsImport
      parentRoute: typeof AuthenticateduserDashboardDashboardDashboardImport
    }
    '/_authenticated/(user-dashboard)/dashboard/_dashboard/analytics': {
      id: '/_authenticated/(user-dashboard)/dashboard/_dashboard/analytics'
      path: '/analytics'
      fullPath: '/dashboard/analytics'
      preLoaderRoute: typeof AuthenticateduserDashboardDashboardDashboardAnalyticsImport
      parentRoute: typeof AuthenticateduserDashboardDashboardDashboardImport
    }
    '/_authenticated/(user-dashboard)/dashboard/_dashboard/locations': {
      id: '/_authenticated/(user-dashboard)/dashboard/_dashboard/locations'
      path: '/locations'
      fullPath: '/dashboard/locations'
      preLoaderRoute: typeof AuthenticateduserDashboardDashboardDashboardLocationsImport
      parentRoute: typeof AuthenticateduserDashboardDashboardDashboardImport
    }
    '/_authenticated/(user-dashboard)/dashboard/_dashboard/settings': {
      id: '/_authenticated/(user-dashboard)/dashboard/_dashboard/settings'
      path: '/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof AuthenticateduserDashboardDashboardDashboardSettingsImport
      parentRoute: typeof AuthenticateduserDashboardDashboardDashboardImport
    }
    '/_authenticated/(user-dashboard)/dashboard/_dashboard/tenants': {
      id: '/_authenticated/(user-dashboard)/dashboard/_dashboard/tenants'
      path: '/tenants'
      fullPath: '/dashboard/tenants'
      preLoaderRoute: typeof AuthenticateduserDashboardDashboardDashboardTenantsImport
      parentRoute: typeof AuthenticateduserDashboardDashboardDashboardImport
    }
    '/_authenticated/(user-dashboard)/dashboard/_monitor-3d/3d-lite': {
      id: '/_authenticated/(user-dashboard)/dashboard/_monitor-3d/3d-lite'
      path: '/3d-lite'
      fullPath: '/dashboard/3d-lite'
      preLoaderRoute: typeof AuthenticateduserDashboardDashboardMonitor3d3dLiteImport
      parentRoute: typeof AuthenticateduserDashboardDashboardMonitor3dImport
    }
    '/_authenticated/(user-dashboard)/dashboard/_monitor-3d/monitor-3d': {
      id: '/_authenticated/(user-dashboard)/dashboard/_monitor-3d/monitor-3d'
      path: '/monitor-3d'
      fullPath: '/dashboard/monitor-3d'
      preLoaderRoute: typeof AuthenticateduserDashboardDashboardMonitor3dMonitor3dImport
      parentRoute: typeof AuthenticateduserDashboardDashboardMonitor3dImport
    }
    '/_authenticated/(user-dashboard)/dashboard/_monitor-3d/scene-editor': {
      id: '/_authenticated/(user-dashboard)/dashboard/_monitor-3d/scene-editor'
      path: '/scene-editor'
      fullPath: '/dashboard/scene-editor'
      preLoaderRoute: typeof AuthenticateduserDashboardDashboardMonitor3dSceneEditorImport
      parentRoute: typeof AuthenticateduserDashboardDashboardMonitor3dImport
    }
    '/_authenticated/(admin-dashboard)/admin/_dashboard/': {
      id: '/_authenticated/(admin-dashboard)/admin/_dashboard/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthenticatedadminDashboardAdminDashboardIndexImport
      parentRoute: typeof AuthenticatedadminDashboardAdminDashboardImport
    }
    '/_authenticated/(user-dashboard)/dashboard/_dashboard/': {
      id: '/_authenticated/(user-dashboard)/dashboard/_dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AuthenticateduserDashboardDashboardDashboardIndexImport
      parentRoute: typeof AuthenticateduserDashboardDashboardDashboardImport
    }
    '/_authenticated/(user-dashboard)/dashboard/_dashboard/devices/$deviceId': {
      id: '/_authenticated/(user-dashboard)/dashboard/_dashboard/devices/$deviceId'
      path: '/devices/$deviceId'
      fullPath: '/dashboard/devices/$deviceId'
      preLoaderRoute: typeof AuthenticateduserDashboardDashboardDashboardDevicesDeviceIdImport
      parentRoute: typeof AuthenticateduserDashboardDashboardDashboardImport
    }
    '/_authenticated/(user-dashboard)/dashboard/_dashboard/devices/': {
      id: '/_authenticated/(user-dashboard)/dashboard/_dashboard/devices/'
      path: '/devices'
      fullPath: '/dashboard/devices'
      preLoaderRoute: typeof AuthenticateduserDashboardDashboardDashboardDevicesIndexImport
      parentRoute: typeof AuthenticateduserDashboardDashboardDashboardImport
    }
    '/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/': {
      id: '/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/'
      path: '/scenes'
      fullPath: '/dashboard/scenes'
      preLoaderRoute: typeof AuthenticateduserDashboardDashboardDashboardScenesIndexImport
      parentRoute: typeof AuthenticateduserDashboardDashboardDashboardImport
    }
    '/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/$sceneId/editor': {
      id: '/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/$sceneId/editor'
      path: '/scenes/$sceneId/editor'
      fullPath: '/dashboard/scenes/$sceneId/editor'
      preLoaderRoute: typeof AuthenticateduserDashboardDashboardDashboardScenesSceneIdEditorImport
      parentRoute: typeof AuthenticateduserDashboardDashboardDashboardImport
    }
    '/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/$sceneId/editor-new': {
      id: '/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/$sceneId/editor-new'
      path: '/scenes/$sceneId/editor-new'
      fullPath: '/dashboard/scenes/$sceneId/editor-new'
      preLoaderRoute: typeof AuthenticateduserDashboardDashboardDashboardScenesSceneIdEditorNewImport
      parentRoute: typeof AuthenticateduserDashboardDashboardDashboardImport
    }
    '/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/$sceneId/view': {
      id: '/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/$sceneId/view'
      path: '/scenes/$sceneId/view'
      fullPath: '/dashboard/scenes/$sceneId/view'
      preLoaderRoute: typeof AuthenticateduserDashboardDashboardDashboardScenesSceneIdViewImport
      parentRoute: typeof AuthenticateduserDashboardDashboardDashboardImport
    }
    '/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/$sceneId/view-new': {
      id: '/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/$sceneId/view-new'
      path: '/scenes/$sceneId/view-new'
      fullPath: '/dashboard/scenes/$sceneId/view-new'
      preLoaderRoute: typeof AuthenticateduserDashboardDashboardDashboardScenesSceneIdViewNewImport
      parentRoute: typeof AuthenticateduserDashboardDashboardDashboardImport
    }
  }
}

// Create and export the route tree

interface AuthenticatedadminDashboardAdminDashboardRouteChildren {
  AuthenticatedadminDashboardAdminDashboardIndexRoute: typeof AuthenticatedadminDashboardAdminDashboardIndexRoute
}

const AuthenticatedadminDashboardAdminDashboardRouteChildren: AuthenticatedadminDashboardAdminDashboardRouteChildren =
  {
    AuthenticatedadminDashboardAdminDashboardIndexRoute:
      AuthenticatedadminDashboardAdminDashboardIndexRoute,
  }

const AuthenticatedadminDashboardAdminDashboardRouteWithChildren =
  AuthenticatedadminDashboardAdminDashboardRoute._addFileChildren(
    AuthenticatedadminDashboardAdminDashboardRouteChildren,
  )

interface AuthenticatedadminDashboardAdminRouteChildren {
  AuthenticatedadminDashboardAdminDashboardRoute: typeof AuthenticatedadminDashboardAdminDashboardRouteWithChildren
}

const AuthenticatedadminDashboardAdminRouteChildren: AuthenticatedadminDashboardAdminRouteChildren =
  {
    AuthenticatedadminDashboardAdminDashboardRoute:
      AuthenticatedadminDashboardAdminDashboardRouteWithChildren,
  }

const AuthenticatedadminDashboardAdminRouteWithChildren =
  AuthenticatedadminDashboardAdminRoute._addFileChildren(
    AuthenticatedadminDashboardAdminRouteChildren,
  )

interface AuthenticateduserDashboardDashboardDashboardRouteChildren {
  AuthenticateduserDashboardDashboardDashboard3dMapRoute: typeof AuthenticateduserDashboardDashboardDashboard3dMapRoute
  AuthenticateduserDashboardDashboardDashboardAiInsightsRoute: typeof AuthenticateduserDashboardDashboardDashboardAiInsightsRoute
  AuthenticateduserDashboardDashboardDashboardAnalyticsRoute: typeof AuthenticateduserDashboardDashboardDashboardAnalyticsRoute
  AuthenticateduserDashboardDashboardDashboardLocationsRoute: typeof AuthenticateduserDashboardDashboardDashboardLocationsRoute
  AuthenticateduserDashboardDashboardDashboardSettingsRoute: typeof AuthenticateduserDashboardDashboardDashboardSettingsRoute
  AuthenticateduserDashboardDashboardDashboardTenantsRoute: typeof AuthenticateduserDashboardDashboardDashboardTenantsRoute
  AuthenticateduserDashboardDashboardDashboardIndexRoute: typeof AuthenticateduserDashboardDashboardDashboardIndexRoute
  AuthenticateduserDashboardDashboardDashboardDevicesDeviceIdRoute: typeof AuthenticateduserDashboardDashboardDashboardDevicesDeviceIdRoute
  AuthenticateduserDashboardDashboardDashboardDevicesIndexRoute: typeof AuthenticateduserDashboardDashboardDashboardDevicesIndexRoute
  AuthenticateduserDashboardDashboardDashboardScenesIndexRoute: typeof AuthenticateduserDashboardDashboardDashboardScenesIndexRoute
  AuthenticateduserDashboardDashboardDashboardScenesSceneIdEditorRoute: typeof AuthenticateduserDashboardDashboardDashboardScenesSceneIdEditorRoute
  AuthenticateduserDashboardDashboardDashboardScenesSceneIdEditorNewRoute: typeof AuthenticateduserDashboardDashboardDashboardScenesSceneIdEditorNewRoute
  AuthenticateduserDashboardDashboardDashboardScenesSceneIdViewRoute: typeof AuthenticateduserDashboardDashboardDashboardScenesSceneIdViewRoute
  AuthenticateduserDashboardDashboardDashboardScenesSceneIdViewNewRoute: typeof AuthenticateduserDashboardDashboardDashboardScenesSceneIdViewNewRoute
}

const AuthenticateduserDashboardDashboardDashboardRouteChildren: AuthenticateduserDashboardDashboardDashboardRouteChildren =
  {
    AuthenticateduserDashboardDashboardDashboard3dMapRoute:
      AuthenticateduserDashboardDashboardDashboard3dMapRoute,
    AuthenticateduserDashboardDashboardDashboardAiInsightsRoute:
      AuthenticateduserDashboardDashboardDashboardAiInsightsRoute,
    AuthenticateduserDashboardDashboardDashboardAnalyticsRoute:
      AuthenticateduserDashboardDashboardDashboardAnalyticsRoute,
    AuthenticateduserDashboardDashboardDashboardLocationsRoute:
      AuthenticateduserDashboardDashboardDashboardLocationsRoute,
    AuthenticateduserDashboardDashboardDashboardSettingsRoute:
      AuthenticateduserDashboardDashboardDashboardSettingsRoute,
    AuthenticateduserDashboardDashboardDashboardTenantsRoute:
      AuthenticateduserDashboardDashboardDashboardTenantsRoute,
    AuthenticateduserDashboardDashboardDashboardIndexRoute:
      AuthenticateduserDashboardDashboardDashboardIndexRoute,
    AuthenticateduserDashboardDashboardDashboardDevicesDeviceIdRoute:
      AuthenticateduserDashboardDashboardDashboardDevicesDeviceIdRoute,
    AuthenticateduserDashboardDashboardDashboardDevicesIndexRoute:
      AuthenticateduserDashboardDashboardDashboardDevicesIndexRoute,
    AuthenticateduserDashboardDashboardDashboardScenesIndexRoute:
      AuthenticateduserDashboardDashboardDashboardScenesIndexRoute,
    AuthenticateduserDashboardDashboardDashboardScenesSceneIdEditorRoute:
      AuthenticateduserDashboardDashboardDashboardScenesSceneIdEditorRoute,
    AuthenticateduserDashboardDashboardDashboardScenesSceneIdEditorNewRoute:
      AuthenticateduserDashboardDashboardDashboardScenesSceneIdEditorNewRoute,
    AuthenticateduserDashboardDashboardDashboardScenesSceneIdViewRoute:
      AuthenticateduserDashboardDashboardDashboardScenesSceneIdViewRoute,
    AuthenticateduserDashboardDashboardDashboardScenesSceneIdViewNewRoute:
      AuthenticateduserDashboardDashboardDashboardScenesSceneIdViewNewRoute,
  }

const AuthenticateduserDashboardDashboardDashboardRouteWithChildren =
  AuthenticateduserDashboardDashboardDashboardRoute._addFileChildren(
    AuthenticateduserDashboardDashboardDashboardRouteChildren,
  )

interface AuthenticateduserDashboardDashboardMonitor3dRouteChildren {
  AuthenticateduserDashboardDashboardMonitor3d3dLiteRoute: typeof AuthenticateduserDashboardDashboardMonitor3d3dLiteRoute
  AuthenticateduserDashboardDashboardMonitor3dMonitor3dRoute: typeof AuthenticateduserDashboardDashboardMonitor3dMonitor3dRoute
  AuthenticateduserDashboardDashboardMonitor3dSceneEditorRoute: typeof AuthenticateduserDashboardDashboardMonitor3dSceneEditorRoute
}

const AuthenticateduserDashboardDashboardMonitor3dRouteChildren: AuthenticateduserDashboardDashboardMonitor3dRouteChildren =
  {
    AuthenticateduserDashboardDashboardMonitor3d3dLiteRoute:
      AuthenticateduserDashboardDashboardMonitor3d3dLiteRoute,
    AuthenticateduserDashboardDashboardMonitor3dMonitor3dRoute:
      AuthenticateduserDashboardDashboardMonitor3dMonitor3dRoute,
    AuthenticateduserDashboardDashboardMonitor3dSceneEditorRoute:
      AuthenticateduserDashboardDashboardMonitor3dSceneEditorRoute,
  }

const AuthenticateduserDashboardDashboardMonitor3dRouteWithChildren =
  AuthenticateduserDashboardDashboardMonitor3dRoute._addFileChildren(
    AuthenticateduserDashboardDashboardMonitor3dRouteChildren,
  )

interface AuthenticateduserDashboardDashboardRouteChildren {
  AuthenticateduserDashboardDashboardDashboardRoute: typeof AuthenticateduserDashboardDashboardDashboardRouteWithChildren
  AuthenticateduserDashboardDashboardMonitor3dRoute: typeof AuthenticateduserDashboardDashboardMonitor3dRouteWithChildren
}

const AuthenticateduserDashboardDashboardRouteChildren: AuthenticateduserDashboardDashboardRouteChildren =
  {
    AuthenticateduserDashboardDashboardDashboardRoute:
      AuthenticateduserDashboardDashboardDashboardRouteWithChildren,
    AuthenticateduserDashboardDashboardMonitor3dRoute:
      AuthenticateduserDashboardDashboardMonitor3dRouteWithChildren,
  }

const AuthenticateduserDashboardDashboardRouteWithChildren =
  AuthenticateduserDashboardDashboardRoute._addFileChildren(
    AuthenticateduserDashboardDashboardRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedadminDashboardAdminRoute: typeof AuthenticatedadminDashboardAdminRouteWithChildren
  AuthenticateduserDashboardDashboardRoute: typeof AuthenticateduserDashboardDashboardRouteWithChildren
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedadminDashboardAdminRoute:
    AuthenticatedadminDashboardAdminRouteWithChildren,
  AuthenticateduserDashboardDashboardRoute:
    AuthenticateduserDashboardDashboardRouteWithChildren,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface NeutralRouteChildren {
  NeutralAcceptInvitationRoute: typeof NeutralAcceptInvitationRoute
  NeutralWaitlistRoute: typeof NeutralWaitlistRoute
}

const NeutralRouteChildren: NeutralRouteChildren = {
  NeutralAcceptInvitationRoute: NeutralAcceptInvitationRoute,
  NeutralWaitlistRoute: NeutralWaitlistRoute,
}

const NeutralRouteWithChildren =
  NeutralRoute._addFileChildren(NeutralRouteChildren)

interface UnauthenticatedRouteChildren {
  UnauthenticatedForgotPasswordRoute: typeof UnauthenticatedForgotPasswordRoute
  UnauthenticatedLoginRoute: typeof UnauthenticatedLoginRoute
  UnauthenticatedResetPasswordRoute: typeof UnauthenticatedResetPasswordRoute
  UnauthenticatedSignupRoute: typeof UnauthenticatedSignupRoute
}

const UnauthenticatedRouteChildren: UnauthenticatedRouteChildren = {
  UnauthenticatedForgotPasswordRoute: UnauthenticatedForgotPasswordRoute,
  UnauthenticatedLoginRoute: UnauthenticatedLoginRoute,
  UnauthenticatedResetPasswordRoute: UnauthenticatedResetPasswordRoute,
  UnauthenticatedSignupRoute: UnauthenticatedSignupRoute,
}

const UnauthenticatedRouteWithChildren = UnauthenticatedRoute._addFileChildren(
  UnauthenticatedRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof UnauthenticatedRouteWithChildren
  '/accept-invitation': typeof NeutralAcceptInvitationRoute
  '/waitlist': typeof NeutralWaitlistRoute
  '/forgot-password': typeof UnauthenticatedForgotPasswordRoute
  '/login': typeof UnauthenticatedLoginRoute
  '/reset-password': typeof UnauthenticatedResetPasswordRoute
  '/signup': typeof UnauthenticatedSignupRoute
  '/admin': typeof AuthenticatedadminDashboardAdminDashboardRouteWithChildren
  '/dashboard': typeof AuthenticateduserDashboardDashboardMonitor3dRouteWithChildren
  '/dashboard/3d-map': typeof AuthenticateduserDashboardDashboardDashboard3dMapRoute
  '/dashboard/ai-insights': typeof AuthenticateduserDashboardDashboardDashboardAiInsightsRoute
  '/dashboard/analytics': typeof AuthenticateduserDashboardDashboardDashboardAnalyticsRoute
  '/dashboard/locations': typeof AuthenticateduserDashboardDashboardDashboardLocationsRoute
  '/dashboard/settings': typeof AuthenticateduserDashboardDashboardDashboardSettingsRoute
  '/dashboard/tenants': typeof AuthenticateduserDashboardDashboardDashboardTenantsRoute
  '/dashboard/3d-lite': typeof AuthenticateduserDashboardDashboardMonitor3d3dLiteRoute
  '/dashboard/monitor-3d': typeof AuthenticateduserDashboardDashboardMonitor3dMonitor3dRoute
  '/dashboard/scene-editor': typeof AuthenticateduserDashboardDashboardMonitor3dSceneEditorRoute
  '/admin/': typeof AuthenticatedadminDashboardAdminDashboardIndexRoute
  '/dashboard/': typeof AuthenticateduserDashboardDashboardDashboardIndexRoute
  '/dashboard/devices/$deviceId': typeof AuthenticateduserDashboardDashboardDashboardDevicesDeviceIdRoute
  '/dashboard/devices': typeof AuthenticateduserDashboardDashboardDashboardDevicesIndexRoute
  '/dashboard/scenes': typeof AuthenticateduserDashboardDashboardDashboardScenesIndexRoute
  '/dashboard/scenes/$sceneId/editor': typeof AuthenticateduserDashboardDashboardDashboardScenesSceneIdEditorRoute
  '/dashboard/scenes/$sceneId/editor-new': typeof AuthenticateduserDashboardDashboardDashboardScenesSceneIdEditorNewRoute
  '/dashboard/scenes/$sceneId/view': typeof AuthenticateduserDashboardDashboardDashboardScenesSceneIdViewRoute
  '/dashboard/scenes/$sceneId/view-new': typeof AuthenticateduserDashboardDashboardDashboardScenesSceneIdViewNewRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof UnauthenticatedRouteWithChildren
  '/accept-invitation': typeof NeutralAcceptInvitationRoute
  '/waitlist': typeof NeutralWaitlistRoute
  '/forgot-password': typeof UnauthenticatedForgotPasswordRoute
  '/login': typeof UnauthenticatedLoginRoute
  '/reset-password': typeof UnauthenticatedResetPasswordRoute
  '/signup': typeof UnauthenticatedSignupRoute
  '/admin': typeof AuthenticatedadminDashboardAdminDashboardIndexRoute
  '/dashboard': typeof AuthenticateduserDashboardDashboardDashboardIndexRoute
  '/dashboard/3d-map': typeof AuthenticateduserDashboardDashboardDashboard3dMapRoute
  '/dashboard/ai-insights': typeof AuthenticateduserDashboardDashboardDashboardAiInsightsRoute
  '/dashboard/analytics': typeof AuthenticateduserDashboardDashboardDashboardAnalyticsRoute
  '/dashboard/locations': typeof AuthenticateduserDashboardDashboardDashboardLocationsRoute
  '/dashboard/settings': typeof AuthenticateduserDashboardDashboardDashboardSettingsRoute
  '/dashboard/tenants': typeof AuthenticateduserDashboardDashboardDashboardTenantsRoute
  '/dashboard/3d-lite': typeof AuthenticateduserDashboardDashboardMonitor3d3dLiteRoute
  '/dashboard/monitor-3d': typeof AuthenticateduserDashboardDashboardMonitor3dMonitor3dRoute
  '/dashboard/scene-editor': typeof AuthenticateduserDashboardDashboardMonitor3dSceneEditorRoute
  '/dashboard/devices/$deviceId': typeof AuthenticateduserDashboardDashboardDashboardDevicesDeviceIdRoute
  '/dashboard/devices': typeof AuthenticateduserDashboardDashboardDashboardDevicesIndexRoute
  '/dashboard/scenes': typeof AuthenticateduserDashboardDashboardDashboardScenesIndexRoute
  '/dashboard/scenes/$sceneId/editor': typeof AuthenticateduserDashboardDashboardDashboardScenesSceneIdEditorRoute
  '/dashboard/scenes/$sceneId/editor-new': typeof AuthenticateduserDashboardDashboardDashboardScenesSceneIdEditorNewRoute
  '/dashboard/scenes/$sceneId/view': typeof AuthenticateduserDashboardDashboardDashboardScenesSceneIdViewRoute
  '/dashboard/scenes/$sceneId/view-new': typeof AuthenticateduserDashboardDashboardDashboardScenesSceneIdViewNewRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_neutral': typeof NeutralRouteWithChildren
  '/_unauthenticated': typeof UnauthenticatedRouteWithChildren
  '/_neutral/accept-invitation': typeof NeutralAcceptInvitationRoute
  '/_neutral/waitlist': typeof NeutralWaitlistRoute
  '/_unauthenticated/forgot-password': typeof UnauthenticatedForgotPasswordRoute
  '/_unauthenticated/login': typeof UnauthenticatedLoginRoute
  '/_unauthenticated/reset-password': typeof UnauthenticatedResetPasswordRoute
  '/_unauthenticated/signup': typeof UnauthenticatedSignupRoute
  '/_authenticated/(admin-dashboard)/admin': typeof AuthenticatedadminDashboardAdminRouteWithChildren
  '/_authenticated/(admin-dashboard)/admin/_dashboard': typeof AuthenticatedadminDashboardAdminDashboardRouteWithChildren
  '/_authenticated/(user-dashboard)/dashboard': typeof AuthenticateduserDashboardDashboardRouteWithChildren
  '/_authenticated/(user-dashboard)/dashboard/_dashboard': typeof AuthenticateduserDashboardDashboardDashboardRouteWithChildren
  '/_authenticated/(user-dashboard)/dashboard/_monitor-3d': typeof AuthenticateduserDashboardDashboardMonitor3dRouteWithChildren
  '/_authenticated/(user-dashboard)/dashboard/_dashboard/3d-map': typeof AuthenticateduserDashboardDashboardDashboard3dMapRoute
  '/_authenticated/(user-dashboard)/dashboard/_dashboard/ai-insights': typeof AuthenticateduserDashboardDashboardDashboardAiInsightsRoute
  '/_authenticated/(user-dashboard)/dashboard/_dashboard/analytics': typeof AuthenticateduserDashboardDashboardDashboardAnalyticsRoute
  '/_authenticated/(user-dashboard)/dashboard/_dashboard/locations': typeof AuthenticateduserDashboardDashboardDashboardLocationsRoute
  '/_authenticated/(user-dashboard)/dashboard/_dashboard/settings': typeof AuthenticateduserDashboardDashboardDashboardSettingsRoute
  '/_authenticated/(user-dashboard)/dashboard/_dashboard/tenants': typeof AuthenticateduserDashboardDashboardDashboardTenantsRoute
  '/_authenticated/(user-dashboard)/dashboard/_monitor-3d/3d-lite': typeof AuthenticateduserDashboardDashboardMonitor3d3dLiteRoute
  '/_authenticated/(user-dashboard)/dashboard/_monitor-3d/monitor-3d': typeof AuthenticateduserDashboardDashboardMonitor3dMonitor3dRoute
  '/_authenticated/(user-dashboard)/dashboard/_monitor-3d/scene-editor': typeof AuthenticateduserDashboardDashboardMonitor3dSceneEditorRoute
  '/_authenticated/(admin-dashboard)/admin/_dashboard/': typeof AuthenticatedadminDashboardAdminDashboardIndexRoute
  '/_authenticated/(user-dashboard)/dashboard/_dashboard/': typeof AuthenticateduserDashboardDashboardDashboardIndexRoute
  '/_authenticated/(user-dashboard)/dashboard/_dashboard/devices/$deviceId': typeof AuthenticateduserDashboardDashboardDashboardDevicesDeviceIdRoute
  '/_authenticated/(user-dashboard)/dashboard/_dashboard/devices/': typeof AuthenticateduserDashboardDashboardDashboardDevicesIndexRoute
  '/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/': typeof AuthenticateduserDashboardDashboardDashboardScenesIndexRoute
  '/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/$sceneId/editor': typeof AuthenticateduserDashboardDashboardDashboardScenesSceneIdEditorRoute
  '/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/$sceneId/editor-new': typeof AuthenticateduserDashboardDashboardDashboardScenesSceneIdEditorNewRoute
  '/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/$sceneId/view': typeof AuthenticateduserDashboardDashboardDashboardScenesSceneIdViewRoute
  '/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/$sceneId/view-new': typeof AuthenticateduserDashboardDashboardDashboardScenesSceneIdViewNewRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/accept-invitation'
    | '/waitlist'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/admin'
    | '/dashboard'
    | '/dashboard/3d-map'
    | '/dashboard/ai-insights'
    | '/dashboard/analytics'
    | '/dashboard/locations'
    | '/dashboard/settings'
    | '/dashboard/tenants'
    | '/dashboard/3d-lite'
    | '/dashboard/monitor-3d'
    | '/dashboard/scene-editor'
    | '/admin/'
    | '/dashboard/'
    | '/dashboard/devices/$deviceId'
    | '/dashboard/devices'
    | '/dashboard/scenes'
    | '/dashboard/scenes/$sceneId/editor'
    | '/dashboard/scenes/$sceneId/editor-new'
    | '/dashboard/scenes/$sceneId/view'
    | '/dashboard/scenes/$sceneId/view-new'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/accept-invitation'
    | '/waitlist'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/admin'
    | '/dashboard'
    | '/dashboard/3d-map'
    | '/dashboard/ai-insights'
    | '/dashboard/analytics'
    | '/dashboard/locations'
    | '/dashboard/settings'
    | '/dashboard/tenants'
    | '/dashboard/3d-lite'
    | '/dashboard/monitor-3d'
    | '/dashboard/scene-editor'
    | '/dashboard/devices/$deviceId'
    | '/dashboard/devices'
    | '/dashboard/scenes'
    | '/dashboard/scenes/$sceneId/editor'
    | '/dashboard/scenes/$sceneId/editor-new'
    | '/dashboard/scenes/$sceneId/view'
    | '/dashboard/scenes/$sceneId/view-new'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_neutral'
    | '/_unauthenticated'
    | '/_neutral/accept-invitation'
    | '/_neutral/waitlist'
    | '/_unauthenticated/forgot-password'
    | '/_unauthenticated/login'
    | '/_unauthenticated/reset-password'
    | '/_unauthenticated/signup'
    | '/_authenticated/(admin-dashboard)/admin'
    | '/_authenticated/(admin-dashboard)/admin/_dashboard'
    | '/_authenticated/(user-dashboard)/dashboard'
    | '/_authenticated/(user-dashboard)/dashboard/_dashboard'
    | '/_authenticated/(user-dashboard)/dashboard/_monitor-3d'
    | '/_authenticated/(user-dashboard)/dashboard/_dashboard/3d-map'
    | '/_authenticated/(user-dashboard)/dashboard/_dashboard/ai-insights'
    | '/_authenticated/(user-dashboard)/dashboard/_dashboard/analytics'
    | '/_authenticated/(user-dashboard)/dashboard/_dashboard/locations'
    | '/_authenticated/(user-dashboard)/dashboard/_dashboard/settings'
    | '/_authenticated/(user-dashboard)/dashboard/_dashboard/tenants'
    | '/_authenticated/(user-dashboard)/dashboard/_monitor-3d/3d-lite'
    | '/_authenticated/(user-dashboard)/dashboard/_monitor-3d/monitor-3d'
    | '/_authenticated/(user-dashboard)/dashboard/_monitor-3d/scene-editor'
    | '/_authenticated/(admin-dashboard)/admin/_dashboard/'
    | '/_authenticated/(user-dashboard)/dashboard/_dashboard/'
    | '/_authenticated/(user-dashboard)/dashboard/_dashboard/devices/$deviceId'
    | '/_authenticated/(user-dashboard)/dashboard/_dashboard/devices/'
    | '/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/'
    | '/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/$sceneId/editor'
    | '/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/$sceneId/editor-new'
    | '/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/$sceneId/view'
    | '/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/$sceneId/view-new'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  NeutralRoute: typeof NeutralRouteWithChildren
  UnauthenticatedRoute: typeof UnauthenticatedRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  NeutralRoute: NeutralRouteWithChildren,
  UnauthenticatedRoute: UnauthenticatedRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_authenticated",
        "/_neutral",
        "/_unauthenticated"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_authenticated": {
      "filePath": "_authenticated.tsx",
      "children": [
        "/_authenticated/(admin-dashboard)/admin",
        "/_authenticated/(user-dashboard)/dashboard"
      ]
    },
    "/_neutral": {
      "filePath": "_neutral.tsx",
      "children": [
        "/_neutral/accept-invitation",
        "/_neutral/waitlist"
      ]
    },
    "/_unauthenticated": {
      "filePath": "_unauthenticated.tsx",
      "children": [
        "/_unauthenticated/forgot-password",
        "/_unauthenticated/login",
        "/_unauthenticated/reset-password",
        "/_unauthenticated/signup"
      ]
    },
    "/_neutral/accept-invitation": {
      "filePath": "_neutral/accept-invitation.tsx",
      "parent": "/_neutral"
    },
    "/_neutral/waitlist": {
      "filePath": "_neutral/waitlist.tsx",
      "parent": "/_neutral"
    },
    "/_unauthenticated/forgot-password": {
      "filePath": "_unauthenticated/forgot-password.tsx",
      "parent": "/_unauthenticated"
    },
    "/_unauthenticated/login": {
      "filePath": "_unauthenticated/login.tsx",
      "parent": "/_unauthenticated"
    },
    "/_unauthenticated/reset-password": {
      "filePath": "_unauthenticated/reset-password.tsx",
      "parent": "/_unauthenticated"
    },
    "/_unauthenticated/signup": {
      "filePath": "_unauthenticated/signup.tsx",
      "parent": "/_unauthenticated"
    },
    "/_authenticated/(admin-dashboard)/admin": {
      "filePath": "_authenticated/(admin-dashboard)/admin",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/(admin-dashboard)/admin/_dashboard"
      ]
    },
    "/_authenticated/(admin-dashboard)/admin/_dashboard": {
      "filePath": "_authenticated/(admin-dashboard)/admin/_dashboard.tsx",
      "parent": "/_authenticated/(admin-dashboard)/admin",
      "children": [
        "/_authenticated/(admin-dashboard)/admin/_dashboard/"
      ]
    },
    "/_authenticated/(user-dashboard)/dashboard": {
      "filePath": "_authenticated/(user-dashboard)/dashboard",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/(user-dashboard)/dashboard/_dashboard",
        "/_authenticated/(user-dashboard)/dashboard/_monitor-3d"
      ]
    },
    "/_authenticated/(user-dashboard)/dashboard/_dashboard": {
      "filePath": "_authenticated/(user-dashboard)/dashboard/_dashboard.tsx",
      "parent": "/_authenticated/(user-dashboard)/dashboard",
      "children": [
        "/_authenticated/(user-dashboard)/dashboard/_dashboard/3d-map",
        "/_authenticated/(user-dashboard)/dashboard/_dashboard/ai-insights",
        "/_authenticated/(user-dashboard)/dashboard/_dashboard/analytics",
        "/_authenticated/(user-dashboard)/dashboard/_dashboard/locations",
        "/_authenticated/(user-dashboard)/dashboard/_dashboard/settings",
        "/_authenticated/(user-dashboard)/dashboard/_dashboard/tenants",
        "/_authenticated/(user-dashboard)/dashboard/_dashboard/",
        "/_authenticated/(user-dashboard)/dashboard/_dashboard/devices/$deviceId",
        "/_authenticated/(user-dashboard)/dashboard/_dashboard/devices/",
        "/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/",
        "/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/$sceneId/editor",
        "/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/$sceneId/editor-new",
        "/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/$sceneId/view",
        "/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/$sceneId/view-new"
      ]
    },
    "/_authenticated/(user-dashboard)/dashboard/_monitor-3d": {
      "filePath": "_authenticated/(user-dashboard)/dashboard/_monitor-3d.tsx",
      "parent": "/_authenticated/(user-dashboard)/dashboard",
      "children": [
        "/_authenticated/(user-dashboard)/dashboard/_monitor-3d/3d-lite",
        "/_authenticated/(user-dashboard)/dashboard/_monitor-3d/monitor-3d",
        "/_authenticated/(user-dashboard)/dashboard/_monitor-3d/scene-editor"
      ]
    },
    "/_authenticated/(user-dashboard)/dashboard/_dashboard/3d-map": {
      "filePath": "_authenticated/(user-dashboard)/dashboard/_dashboard/3d-map.tsx",
      "parent": "/_authenticated/(user-dashboard)/dashboard/_dashboard"
    },
    "/_authenticated/(user-dashboard)/dashboard/_dashboard/ai-insights": {
      "filePath": "_authenticated/(user-dashboard)/dashboard/_dashboard/ai-insights.tsx",
      "parent": "/_authenticated/(user-dashboard)/dashboard/_dashboard"
    },
    "/_authenticated/(user-dashboard)/dashboard/_dashboard/analytics": {
      "filePath": "_authenticated/(user-dashboard)/dashboard/_dashboard/analytics.tsx",
      "parent": "/_authenticated/(user-dashboard)/dashboard/_dashboard"
    },
    "/_authenticated/(user-dashboard)/dashboard/_dashboard/locations": {
      "filePath": "_authenticated/(user-dashboard)/dashboard/_dashboard/locations.tsx",
      "parent": "/_authenticated/(user-dashboard)/dashboard/_dashboard"
    },
    "/_authenticated/(user-dashboard)/dashboard/_dashboard/settings": {
      "filePath": "_authenticated/(user-dashboard)/dashboard/_dashboard/settings.tsx",
      "parent": "/_authenticated/(user-dashboard)/dashboard/_dashboard"
    },
    "/_authenticated/(user-dashboard)/dashboard/_dashboard/tenants": {
      "filePath": "_authenticated/(user-dashboard)/dashboard/_dashboard/tenants.tsx",
      "parent": "/_authenticated/(user-dashboard)/dashboard/_dashboard"
    },
    "/_authenticated/(user-dashboard)/dashboard/_monitor-3d/3d-lite": {
      "filePath": "_authenticated/(user-dashboard)/dashboard/_monitor-3d/3d-lite.tsx",
      "parent": "/_authenticated/(user-dashboard)/dashboard/_monitor-3d"
    },
    "/_authenticated/(user-dashboard)/dashboard/_monitor-3d/monitor-3d": {
      "filePath": "_authenticated/(user-dashboard)/dashboard/_monitor-3d/monitor-3d.tsx",
      "parent": "/_authenticated/(user-dashboard)/dashboard/_monitor-3d"
    },
    "/_authenticated/(user-dashboard)/dashboard/_monitor-3d/scene-editor": {
      "filePath": "_authenticated/(user-dashboard)/dashboard/_monitor-3d/scene-editor.tsx",
      "parent": "/_authenticated/(user-dashboard)/dashboard/_monitor-3d"
    },
    "/_authenticated/(admin-dashboard)/admin/_dashboard/": {
      "filePath": "_authenticated/(admin-dashboard)/admin/_dashboard/index.tsx",
      "parent": "/_authenticated/(admin-dashboard)/admin/_dashboard"
    },
    "/_authenticated/(user-dashboard)/dashboard/_dashboard/": {
      "filePath": "_authenticated/(user-dashboard)/dashboard/_dashboard/index.tsx",
      "parent": "/_authenticated/(user-dashboard)/dashboard/_dashboard"
    },
    "/_authenticated/(user-dashboard)/dashboard/_dashboard/devices/$deviceId": {
      "filePath": "_authenticated/(user-dashboard)/dashboard/_dashboard/devices/$deviceId.tsx",
      "parent": "/_authenticated/(user-dashboard)/dashboard/_dashboard"
    },
    "/_authenticated/(user-dashboard)/dashboard/_dashboard/devices/": {
      "filePath": "_authenticated/(user-dashboard)/dashboard/_dashboard/devices/index.tsx",
      "parent": "/_authenticated/(user-dashboard)/dashboard/_dashboard"
    },
    "/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/": {
      "filePath": "_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/index.tsx",
      "parent": "/_authenticated/(user-dashboard)/dashboard/_dashboard"
    },
    "/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/$sceneId/editor": {
      "filePath": "_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/$sceneId/editor.tsx",
      "parent": "/_authenticated/(user-dashboard)/dashboard/_dashboard"
    },
    "/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/$sceneId/editor-new": {
      "filePath": "_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/$sceneId/editor-new.tsx",
      "parent": "/_authenticated/(user-dashboard)/dashboard/_dashboard"
    },
    "/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/$sceneId/view": {
      "filePath": "_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/$sceneId/view.tsx",
      "parent": "/_authenticated/(user-dashboard)/dashboard/_dashboard"
    },
    "/_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/$sceneId/view-new": {
      "filePath": "_authenticated/(user-dashboard)/dashboard/_dashboard/scenes/$sceneId/view-new.tsx",
      "parent": "/_authenticated/(user-dashboard)/dashboard/_dashboard"
    }
  }
}
ROUTE_MANIFEST_END */
